import { useMemo } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import { PinProvider } from "@/contexts/PinContext";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Confirm from "@/pages/Confirm";
import KaiQuestionnairePage from "@/pages/KaiQuestionnairePage";
import SignaturePage from "@/pages/SignaturePage";
import DgtSignaturePage from "@/pages/DgtSignaturePage";
import AvailabilityQuestionnairePage from "@/pages/AvailabilityQuestionnairePage";
import AltaDigitalPage from "@/pages/AltaDigitalPage";
import DocumentBundlePage from "@/pages/DocumentBundlePage";
import PsicotecnicoPage from "@/pages/PsicotecnicoPage";
import "@/App.css";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  const redirectState = useMemo(() => ({ from: loc }), [loc]);
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="text-neutral-500" data-testid="loading-indicator">Cargando…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={redirectState} replace />;
  return children;
}

function App() {
  return (
    <div className="App min-h-screen bg-white text-neutral-950">
      <AuthProvider>
        <BrowserRouter>
          <PinProvider>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/confirm" element={<Confirm />} />
              <Route path="/kai/cuestionario" element={<KaiQuestionnairePage />} />
              <Route path="/kai/cuestionario/:token" element={<KaiQuestionnairePage />} />
              <Route path="/firmar/:token" element={<SignaturePage />} />
              <Route path="/firmar-dgt/:token" element={<DgtSignaturePage />} />
              <Route path="/horarios/cuestionario/:token" element={<AvailabilityQuestionnairePage />} />
              <Route path="/alta/:token" element={<AltaDigitalPage />} />
              <Route path="/documentos/:token" element={<DocumentBundlePage />} />
              <Route path="/psicotecnico/:token" element={<PsicotecnicoPage />} />
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <Toaster richColors position="top-right" />
          </PinProvider>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
